<template>
  <div class="footer" :style="{ background: (this.$route.name === 'aboutus' ? '#ffffff' : '#f2f2f2') }">
    <div class="wrap">
      <div class="box">
        <div class="item0">
          <strong>加入我们</strong>
          <a href="javascript:;" @click="$router.push({ name: 'recruit'})">招聘职位</a>
        </div>
        <div class="item1">
          <strong>友情链接</strong>
          <template v-for="(partner, index) in partnerList">
            <a v-if="index < 6" :key="index" :href="partner.url" target="_black">{{ partner.name }}</a>
          </template>
        </div>
        <div class="item2">
          <strong>联系我们</strong>
          <div class="list1">
            <span>地址：</span>
            <p>{{company.address}}</p>
          </div>
          <div class="list2">
            <p>电话：{{company.phone}}</p>
            <p>传真：{{company.call}}</p>
          </div>
          <div class="list3">
            <p>{{company.email}}</p>
          </div>
        </div>
        <div class="item3">
          <img src="../../assets/logo_foot.png" width="200" alt="">
        </div>
      </div>
      <div class="tips">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_black">©2021集百优技术有限公司 版权所有 桂ICP备10201431号-1</a>

      </div>
    </div>
  </div>
</template>

<script>
import util from '../../utils'
import {ApiWebFooterPartner, ApiWebCompanyInfo} from '../../api/company'
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      partnerList: [],
      company: {}
    }
  },
  created () {
    this.initPartnerList()
    this.initCompanyInfo()
  },
  methods: {
    /**
     * 页脚-合作伙伴
     */
    initPartnerList () {
      ApiWebFooterPartner().then(({data}) => {
        if (data && data.status === 0) {
          this.partnerList = data.data
        }
      })
    },
    /**
     * 页脚-公司信息
     */
    initCompanyInfo () {
      ApiWebCompanyInfo().then(({data}) => {
        if (data && data.status === 0) {
          this.$set(this.company, 'address', data.data.address ? util.delHtmlTag(data.data.address.content) : '')
          this.$set(this.company, 'phone', data.data.phone ? util.delHtmlTag(data.data.phone.content) : '')
          this.$set(this.company, 'call', data.data.call ? util.delHtmlTag(data.data.call.content) : '')
          this.$set(this.company, 'email', data.data.email ? util.delHtmlTag(data.data.email.content) : '')
          this.$set(this.company, 'post', data.data.post ? util.delHtmlTag(data.data.post.content) : '')
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
a {
  text-decoration: none;
}
.footer{
  position: relative;
  z-index: 99;
  height: 392px;
  background: #f2f2f2;
  clear: both;
  .wrap {
    width: 1552px;
    height: 100%;
    margin: 0 auto;
    .box {
      padding-top: 80px;
      display: flex;
      .item0,.item1,.item2,.item3{
        width: 388px;
        float: left;
        padding-left: 10px;
      }
      .item1{
        a{
          padding-left: 20px;
          color: #666666;
          position: relative;
          display: block;
          height: 14px;
          line-height: 14px;
          font-size: 14px;
          margin-bottom: 15px;
          background: url('~@/assets/img/footer_01.png') left center no-repeat;
          background-size: 10px auto;
      
          &:hover{
            color: #dc252b;
            background: url('~@/assets/img/footer_01_hover.png') left center no-repeat;
            background-size: 10px auto;
          }
        }
      }
      .item2{
        .list1,.list2,.list3{
          height: 56px;
          margin-bottom: 10px;
          border-bottom: 1px solid #666666;
          padding-left: 30px;
          background: url('~@/assets/img/c_list1.png') left top no-repeat;
          background-size: 19px auto;
          span,p{
            color: #666666;
            font-size: 14px;
            display: block;
            line-height: 18px;
            padding: 0;
            margin: 0;
          }
        }
        .list1{
          background: url('~@/assets/img/c_list1.png') left top no-repeat;
          background-size: 19px auto;
          span,p{
            float: left;
          }
          span{
            width: 45px;
          }
          p{
           width: 200px
          }
        }
        .list2{
          border-bottom: none;
          background: url('~@/assets/img/c_list2.png') left top no-repeat;
          background-size: 19px auto;
        }
        .list3{
          border-bottom: none;
          background: url('~@/assets/img/c_list3.png') left top no-repeat;
          background-size: 19px auto;
        }
      }
      .item3 {
        text-align: center;
      }
    }
    .tips{
      position: absolute;
      bottom: 18px;
      height: 20px;
      width: 1552px;
      text-align: center;
      a{
        color: #000000;
      }
    }
    a,p,span,strong{
      display: block;
      font-size: 14px;
      height: 24px;
      line-height: 24px;
    }
    strong{margin-bottom: 30px;}
    .item0 a{ font-weight: bold;}
    strong, .item0 a{
      font-size: 16px;
      height: 18px;
      line-height: 18px;
      border-bottom: 1px solid #111111;
      color: #111111;
      width: 66px;
      &:hover{
        border-bottom: 1px solid #dc252b;
        color: #dc252b;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/template/footer-template.vue